import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import ContentContainer from '../../components/ContentContainer';
import EditProfileSummary from '../../components/EditProfileSummary';
import HorizontalRule from '../../components/HorizontalRule';

class SettingsDetails extends Component {
  getUserImage() {
    const user = this.props.user;

    if (user.image_url && user.image_url.length > 10) {
      return user.image_url;
    }

    if (user.profile_photo && user.profile_photo.length > 10) {
      return user.profile_photo;
    }

    return '/images/default_profile.jpg';
  }

  getDogImage(dog) {
    if (dog.image_url && dog.image_url.length > 10) {
      return dog.image_url;
    }

    if (dog.profile_photo && dog.profile_photo.length > 10) {
      return dog.profile_photo;
    }

    return '/images/default_dog.jpg';
  }

  getDogs() {
    return this.props.user.dogs.map(dog => (
      <EditProfileSummary
        id={dog.id}
        image_url={this.getDogImage(dog)}
        name={dog.name}
        breed={dog.breed}
      />
    ));
  }

  render() {
    return (
      <ContentContainer>
        <div className={css(styles.container)}>
          <div className={css(styles.profiles_container)}>
            <EditProfileSummary
              dog={false}
              id={this.props.user.id}
              image_url={this.getUserImage()}
              name={this.props.user.display_name}
            />
            {this.props.user.dogs && this.props.user.dogs.length > 0 ? this.getDogs() : false}
          </div>
          <HorizontalRule />
        </div>
      </ContentContainer>
    );
  }
}

SettingsDetails.propTypes = {
  user: PropTypes.object.isRequired,
  dogs: PropTypes.array.isRequired,
};

const styles = StyleSheet.create({
  container: {
    width: 800,
    margin: '0 auto',

    [Theme.mobile_query]: {
      width: 'auto',
    },
  },
  h2: {
    fontSize: 20,
    margin: '45px 5px',
  },
  form_group: {
    display: 'flex',
    flexDirection: 'row',
  },
  button_container: {
    display: 'flex',
    justifyContent: 'flex-end',

    [Theme.mobile_query]: {
      justifyContent: 'center',
    },
  },
  profiles_container: {
    marginTop: 50,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsDetails);



// WEBPACK FOOTER //
// ./src/views/SettingsDetails/index.js